import React from 'react';
import {useSelector} from "react-redux";
import styled, {useTheme} from "styled-components";
import {PropTypes} from "prop-types";
import { ReactComponent as LanguageIcon } from '../resources/images/languageIcon.svg';

const ToggleButton = styled.button`
    color: ${props => props.theme.footerColor || "#ffffff" };
    border-bottom: 1px solid  ${props => props.theme.footerColor || "#ffffff" };
    padding: 0.375rem 0;
`;

const ToggleLabel = styled.span`
    padding: 0.375rem 0;
    margin-right: 1rem;
`;

const ChooseLanguageContainer = styled.div`
    display: flex;
    height: ${props => props.theme.footerHeight || "50px" };
    align-items: center;
    justify-content: center;
`;

const DefaultLangIcon = styled(LanguageIcon)`
    fill: ${props => props.listOpen ? props.theme.footerColor || "white" : props.theme.footerBackground || "rgba(12, 12, 12, 0.75)"};
`;

const DefaultLangIconContainer = styled.div`
    max-width: 35px;
    height: 35px;
    border-radius: 10px;
    border: ${props => `2px solid ${props.theme.footerColor || "white"}`} ;
    display: flex;
    align-items: center;
    background-color: ${props => props.listOpen ? "transparent" : props.theme.footerColor || "white" }
`;

const LanguageSelection = ({hubLanguages, isIcon, toggle, listOpen}, context) => {
    const language = useSelector(state => state.i18nState.lang);
    const selectedLanguage = hubLanguages.find((lang) => lang.code === language);
    const selectedLanguageLabel = selectedLanguage ? selectedLanguage.name : "";
    const theme = useTheme();

    const LangIcon = () => {
        if (theme.altFooterLangIcon) {
            return (
                <img
                    alt="Select Language"
                    src={listOpen ? theme.altFooterLangIconInverted : theme.altFooterLangIcon}
                    width={40}
                    onClick={toggle}
                />
            )
        }
        return (
            <DefaultLangIconContainer listOpen={listOpen}>
                <DefaultLangIcon listOpen={listOpen} height={25} onClick={toggle}/>
            </DefaultLangIconContainer>
        )
    }

    if (hubLanguages?.length < 2) {
        return <></>
    }

    return (
            <ChooseLanguageContainer>
                { isIcon ?
                    <LangIcon/>
                    :
                    <>
                        <ToggleLabel>{context.t("choose_language_label")}</ToggleLabel>
                        <ToggleButton onClick={toggle}>
                            {selectedLanguageLabel} <i className={`ml-2 fa fa-chevron-${listOpen ? "up" : "down"}`}/>
                        </ToggleButton>
                    </>
                }
            </ChooseLanguageContainer>
    );
};

LanguageSelection.contextTypes = {
    t: PropTypes.func.isRequired
}

export default LanguageSelection;